import React from 'react';

import { Form, Upload } from 'antd';
import styled from 'styled-components';

import { FILE_STATUS } from 'common/constants.files';
import DefaultItemRender from 'components/lib/UploadDefaultItemRender';
import { normalizeUploadFileListEvent } from 'utils/helpers/files';

const { Dragger } = Upload;

const StyledDragger = styled(Dragger)`
  .ant-upload-drag .ant-upload {
    padding: 0 !important;
  }

  .ant-upload-drag {
    background-color: white;
    border-radius: 0px !important;
    height: 70px !important;
  }

  .ant-upload-btn {
    border-radius: 0px !important;
    height: 70px !important;
  }

  .ant-upload-list {
    display: flex;
    flex-direction: column;
    margin-left: 0;

    .ant-upload-list-item-container {
      width: 100%;
      margin-left: 0 !important;
    }
  }

  .ant-upload-list::before {
    display: none !important;
  }

  .ant-upload-list-item-name {
    display: none;
  }
`;

const DraggerText = styled.div`
  font-size: 14px;
  color: var(--gray-dark);
`;

const BrowseText = styled.span`
  color: var(--dark-blue);
  margin-left: 3px;
`;

type Props = {
  name: any[];
  label: string;
  itemRender?: any;
  accept?: string;
  multiple?: boolean;
  maxCount?: number;
  disabled?: boolean;
  fileList?: any;
  dataTestId?: string;
  beforeUpload?: (file: File) => boolean | string;
};

const ShopDataModalDraggerField = ({
  name,
  label,
  itemRender = DefaultItemRender,
  multiple,
  accept,
  disabled,
  maxCount,
  fileList,
  dataTestId,
  beforeUpload,
}: Props) => {
  const handleCustomRequest = (options: any) => {
    const { file, onSuccess } = options;
    file.status = FILE_STATUS.UPLOADING;

    setTimeout(() => {
      file.status = FILE_STATUS.DONE;
      onSuccess(FILE_STATUS.DONE);
    }, 1500);
  };

  return (
    <Form.Item
      style={{ width: '100%' }}
      name={name}
      valuePropName="files"
      getValueFromEvent={normalizeUploadFileListEvent}
    >
      <StyledDragger
        disabled={disabled}
        itemRender={itemRender}
        multiple={multiple}
        accept={accept}
        beforeUpload={beforeUpload}
        customRequest={handleCustomRequest}
        maxCount={maxCount}
        fileList={fileList}
        data-test-id={dataTestId}
      >
        <img alt="attachment" src="/icons/attachment.svg" width="24px" height="24px" />
        <DraggerText>
          {`Drag ${label} into this area, or click here to`}
          <BrowseText>browse files</BrowseText>.
        </DraggerText>
      </StyledDragger>
    </Form.Item>
  );
};

export default ShopDataModalDraggerField;
